document.addEventListener('DOMContentLoaded', function () {
  const messageBox = document.getElementById('product-variant-estimated-date');
  if (!messageBox) {
    return;
  }

  const productData = JSON.parse(document.getElementById('ProductJSON').textContent);
  const variantsData = productData.variants;

  const globalEddData = JSON.parse(document.getElementById('LskProductVariantsEddJSON').textContent);
  const globalEddInfoHTML = JSON.parse(document.getElementById('LskProductVariantsEddInfoHTML').textContent);

  const holidays = JSON.parse(document.getElementById('LskHolidaysJSON').textContent) || [];

  function isHoliday(date) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const dateStr = `${yyyy}-${mm}-${dd}`;
    return holidays.includes(dateStr);
  }

  function getSelectedVariantInput() {
    const variantInput = document.querySelector('[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  function showMessageBox(html) {
    messageBox.innerHTML = html;
    setTimeout(() => {
      messageBox.classList.add('show');
    }, 10);
  }

  function hideMessageBox() {
    messageBox.classList.remove('show');
    setTimeout(() => {
      messageBox.innerHTML = '';
    }, 400);
  }

  function getFormattedDate(increaseDays = 0, initialDate = null) {
    let date = initialDate ? new Date(initialDate.getTime()) : new Date();
    let addedDays = 0;

    while (addedDays < increaseDays) {
      date.setDate(date.getDate() + 1);
      // 0 = Sunday, 6 = Saturday
      if (date.getDay() !== 0 && date.getDay() !== 6 && !isHoliday(date)) {
        addedDays++;
      }
    }

    const day = date.getDate().toString().padStart(2, '0');
    let month = date.toLocaleDateString('pt-BR', { month: 'long' });
    month = month.charAt(0).toUpperCase() + month.slice(1);

    return `${day} ${month}`;
  }

  function getEddData(variant) {
    const variantId = `gid://shopify/ProductVariant/${variant.id}`;
    const productId = `gid://shopify/Product/${productData.id}`;

    let eddData = globalEddData.find((data) => data.variants && data.variants.includes(variantId));

    if (!eddData) {
      eddData = globalEddData.find((data) => data.products && data.products.includes(productId));
    }

    if (!eddData) {
      eddData = globalEddData.find((data) => data.default_config);
    }

    if (eddData) {
      return {
        ...eddData,
        infoHTML: globalEddInfoHTML[globalEddData.indexOf(eddData)],
      };
    }

    return undefined;
  }

  function getDynamicContent(eddData) {
    const purchaseDate = getFormattedDate();

    let startProductionDate;
    let endProductionDate;
    let startShippingDate;
    let endShippingDate;

    let futureProductionDate = null;
    if (eddData.future_production_date) {
      const [year, month, day] = eddData.future_production_date.split('T')[0].split('-');
      futureProductionDate = new Date(Number(year), Number(month) - 1, Number(day));

      startProductionDate = getFormattedDate(0, futureProductionDate);
      endProductionDate = getFormattedDate(eddData.production_days - 1, futureProductionDate);
      startShippingDate = getFormattedDate(eddData.production_days, futureProductionDate);
      endShippingDate = getFormattedDate(eddData.production_days + eddData.delivery_days - 1, futureProductionDate);
    } else {
      startProductionDate = getFormattedDate(1);
      endProductionDate = getFormattedDate(eddData.production_days);
      startShippingDate = getFormattedDate(eddData.production_days + 1);
      endShippingDate = getFormattedDate(eddData.production_days + eddData.delivery_days);
    }

    return [
      eddData.infoHTML,
      purchaseDate,
      `${startProductionDate} - ${endProductionDate}`,
      `${startShippingDate} - ${endShippingDate}`,
    ];
  }

  function updateMessage() {
    const variantId = getSelectedVariantInput();
    const variant = variantsData.find((v) => v.id == variantId);

    if (!variant || !variant.available) {
      hideMessageBox();
      return;
    }

    const eddData = getEddData(variant);

    if (!eddData) {
      hideMessageBox();
      return;
    }

    const iconPurchase = document.getElementById('icon-purchase').innerHTML;
    const iconProduction = document.getElementById('icon-production').innerHTML;
    const iconDelivery = document.getElementById('icon-delivery').innerHTML;

    const content = getDynamicContent(eddData);

    const timelineHTML = `
      <div class="pved-timeline">
        <div class="pved-timeline-step">
          <div class="pved-timeline-icon" aria-label="Compra efetuada">
            ${iconPurchase}
          </div>
          <div class="pved-timeline-title">Compra efetuada</div>
          <div class="pved-timeline-date">${content[1]}</div>
        </div>
        <div class="pved-timeline-step">
          <div class="pved-timeline-icon" aria-label="Produção / Envio">
            ${iconProduction}
          </div>
          <div class="pved-timeline-title">Produção / Envio</div>
          <div class="pved-timeline-date">${content[2]}</div>
        </div>
        <div class="pved-timeline-step">
          <div class="pved-timeline-icon" aria-label="Prazo de Entrega">
            ${iconDelivery}
          </div>
          <div class="pved-timeline-title">Prazo de Entrega</div>
          <div class="pved-timeline-date">${content[3]}</div>
        </div>
      </div>
    `;
    showMessageBox(`
      <div class="pved-info">${content[0]}</div>
      ${timelineHTML}
    `);
  }

  updateMessage();

  document.querySelector('form[action*="/cart/add"]').addEventListener('change', updateMessage);
});
